// extracted by mini-css-extract-plugin
export var avatarContainer = "_1f-0";
export var avatarTypingWave = "_1f-i";
export var gray = "_1f-f";
export var green = "_1f-c";
export var icon = "_1f-9";
export var image = "_1f-1";
export var lg = "_1f-6";
export var md = "_1f-5";
export var presenceDot = "_1f-b";
export var red = "_1f-d";
export var sm = "_1f-4";
export var status = "_1f-a";
export var typingDot = "_1f-h";
export var typingPill = "_1f-g";
export var xl = "_1f-7";
export var xs = "_1f-3";
export var xxl = "_1f-8";
export var xxs = "_1f-2";
export var yellow = "_1f-e";